<template>
    <div id="ModalClaimNoteEdit">
         <b-modal size="xl" :id="ModalId" :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" ref="modalcategory" @close="this.emitEventCancel" @ok="this.emitEventOK" @cancel="this.emitEventCancel"  
         :cancel-title="$t('Shared.BtnCancel')" 
         :ok-only="IsReadOnly"
         :ok-title="IsReadOnly ? $t('Close') : $t('Shared.BtnOk')"> 
            <MdMemo
                v-bind:Name="'note'"
                v-bind:Rows="'5'"
                v-bind:MaxRows="'250'"    
                v-bind:isReadOnly="IsReadOnly"       
                v-model="Note" />
        </b-modal>
    </div>
</template>

<script>
import ClaimHistory from '@/services/claimhistory.service';
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import LocalStorage from '@/services/storage.service'
export default {
    name: "ClaimNoteModalEdit",
    mixins: [ShowMessage, DBFunctions],
    props: {
        ModalId: String,
        TitleWindow: String,  
        ModelNote: String,
        IsReadOnly: Boolean,
        NoteItems: {
            type: Array,
            default: () => []
        },
        SeqNo: Number,
        EmployeeCode: String,
    },
    data() {
        return {
            Note: this.ModelNote,
            addNoteParameter: {
                SeqNo: this.SeqNo,
                EmployeeCode: this.EmployeeCode,
                Note: '',
                SysDate: new Date(),
            }
        }
    },
    methods:{
        emitEventCancel(){
            this.$emit('getViewOk',false);
        },

        emitEventOK(){
            if(this.IsReadOnly == false) {
                const bulkParams = this.NoteItems.map(item => ({
                    SeqNo: item.seqNo,
                    Note: this.Note,
                    EmployeeCode: LocalStorage.getUserId(),
                    SysDate: new Date(),
                }))
                ClaimHistory.bulkInsertNoteHistory(bulkParams).then((response) => {
                    console.log(response.data)
                    this.$emit('getViewOk',true);
                }).catch((error) => {
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
            }
            else {
                this.$emit('getViewOk',false);
            }
        },
    }
}
</script>